import { createFileRoute } from "@tanstack/react-router";
import { Page, SectionEyebrow } from "@/components/SiteLayout";

export const Route = createFileRoute("/werken-bij")({
  head: () => ({
    meta: [
      { title: "Werken bij Hi Coach" },
      { name: "description", content: "Word coach bij Hi Coach. Een kleine club waar jouw stem telt en je elke zondag het verschil maakt." },
      { property: "og:title", content: "Werken bij Hi Coach" },
      { property: "og:description", content: "Jij bent niet zomaar een coach." },
      { property: "og:url", content: "/werken-bij" },
    ],
    links: [{ rel: "canonical", href: "/werken-bij" }],
  }),
  component: Werken,
});

function Werken() {
  const blocks = [
    { c: "#FF0000", t: "Wat je gaat doen", d: "Als coach bij Hi Coach begeleid je elke zondagochtend een kleine groep kinderen van 2 tot 6 jaar door een avontuur vol bewegen, verhalen en ontdekking. Jij bent het vertrouwde gezicht bij de deur. Jij bent degene die elk kind bij naam kent. Jij bent de reden dat kinderen elke week weer willen komen." },
    { c: "#1E90FF", t: "Wie we zoeken", d: "Je hebt een achtergrond in sport, onderwijs of hulpverlening. Maar belangrijker dan je cv is je overtuiging. Je gelooft dat de jaren tussen 2 en 6 bepalend zijn. Je ziet bewegen niet als doel maar als middel. En je begrijpt dat een kind dat zich gezien voelt, verder komt dan een kind dat alleen maar goed is in één sport." },
    { c: "#00C851", t: "Wat we bieden", d: "Een kleine club waar jouw stem telt. Een concept waar je trots op kunt zijn. En de kans om elke zondagochtend het verschil te maken in het leven van een kind." },
  ];
  return (
    <Page>
      <section className="pt-24 pb-10 bg-white">
        <div className="mx-auto max-w-4xl px-6">
          <SectionEyebrow color="var(--rb-yellow)">Werken bij</SectionEyebrow>
          <h1 className="text-4xl md:text-6xl font-extrabold leading-tight">
            Jij bent niet <span style={{ color: "var(--rb-yellow)" }}>zomaar een coach</span>
          </h1>
          <div className="mt-6 space-y-5 text-lg">
            <p>
              Je bent iemand die onthoudt hoe het voelde om als kind voor het eerst iets te durven. Die ziet wanneer
              een kind aan de kant staat en daar niet zomaar overheen stapt. Die begrijpt dat een zondagochtend in een
              gymzaal veel meer kan zijn dan een uurtje bewegen.
            </p>
            <p className="font-extrabold">Als jij dit leest en denkt "ja, dat ben ik" dan willen we je spreken.</p>
          </div>
        </div>
      </section>

      <section className="py-16 gradient-rainbow-soft">
        <div className="mx-auto max-w-5xl px-6 grid md:grid-cols-3 gap-6">
          {blocks.map((b) => (
            <div key={b.t} className="bg-white rounded-3xl p-7 shadow-md border-t-8" style={{ borderTopColor: b.c }}>
              <h3 className="text-xl font-extrabold" style={{ color: b.c }}>{b.t}</h3>
              <p className="mt-3 text-base/relaxed">{b.d}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="py-20 bg-white text-center">
        <div className="mx-auto max-w-2xl px-6">
          <p className="text-xl font-extrabold">
            Hi Coach groeit. En we groeien liever met de juiste mensen dan snel met de verkeerde.
          </p>
          <h2 className="mt-10 text-3xl md:text-4xl font-extrabold">Herken jij jezelf hierin?</h2>
          <a href="https://wa.me/31626716754" className="btn-cta mt-6 inline-flex">Stuur ons een bericht via WhatsApp</a>
        </div>
      </section>
    </Page>
  );
}
